export const updateStates = ({ id, value, expenseCodes, setFieldValue }) => {
  const updatedExpenseCodes = (expenseCodes || []).map(code =>
    code.id === id
      ? {
          ...code,
          isExpenseEntryToThisCodeAllowed: value
        }
      : code
  );

  setFieldValue('expenseCodes', updatedExpenseCodes);
  setFieldValue(
    'isAddExpenseCodeButtonEnabled',
    updatedExpenseCodes.some(code => !code.isExpenseEntryToThisCodeAllowed)
  );
};

export const useOnChangeHandlers = ({
  setFieldValue,
  expenseCodes,
  onMenuClose
}) => {
  return {
    onAdd: e => {
      updateStates({
        id: e.target.id,
        value: true,
        expenseCodes,
        setFieldValue
      });

      onMenuClose();
    },
    onRemove: ({ id }) => () =>
      updateStates({ id, value: false, expenseCodes, setFieldValue })
  };
};
